export default "__VITE_ASSET__74d26c87__"